import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostHerausgeberCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostHerausgeberCommandService],
  exports: []
})
export class PostHerausgeberCommandServiceModule { }
